import { type FetchLedgersSummaryParams, type WalletLedgerSummary } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchLedgerSummary } from '../api';

import { LedgerSummaryQueryKey } from './useLedgerSummaryByIdQuery';

/**
 *
 * @returns LedgerSummary
 */
export const useLedgerSummaryQuery = <TData = Array<WalletLedgerSummary> | undefined>(
	select?: (data: Array<WalletLedgerSummary> | undefined) => TData,
	params?: FetchLedgersSummaryParams
) =>
	useQuery({
		queryFn: () =>
			fetchLedgerSummary({
				'details[]': ['currency', 'nonTradableDetails', 'inUseDetails', 'stakeAndScoreDetails'],
				...params
			}),
		queryKey: [LedgerSummaryQueryKey, params],
		select: select as (data: Array<WalletLedgerSummary> | unknown) => TData
	});
